import { BioweaveAuthError } from '@bioweave/api-client/errors';

// Synchronous token reader, registered by AuthProvider, read by consoleApi.
let _reader: () => string | null = () => null;
export function setAuthTokenReader(fn: () => string | null): void { _reader = fn; }
export function getAuthToken(): string | null { return _reader(); }

/** The bearer each refused request carried, so a 401 can be told apart from a later one. */
const sentWith = new WeakMap<BioweaveAuthError, string | null>();

/** The auth error for a refused request, remembering the bearer it left with (null: none).
 *  A 401 on a token this tab has since replaced says nothing about the current session. */
export function unauthorised(path: string, init: RequestInit | undefined, status = 401): BioweaveAuthError {
  const e = new BioweaveAuthError('Unauthorised', status, path);
  const header = new Headers(init?.headers).get('Authorization');
  sentWith.set(e, header?.startsWith('Bearer ') ? header.slice('Bearer '.length) : null);
  return e;
}

/** The bearer a refused request carried: null for none, undefined when not recorded. */
export function tokenSentWith(e: unknown): string | null | undefined {
  return e instanceof BioweaveAuthError ? sentWith.get(e) : undefined;
}
